import {Grid, UnstableCard as Paper} from '@yandex-delivery/blocks'
import type {ReactElement} from 'react'

import type {SectionProps as Props} from '../types'
import {Requirements} from './components/Requirements@desktop'
import * as classes from './index@desktop.classes'
import {groupByWidgetId} from './index@desktop.utils'

export function BusinessBanner(props: Props): ReactElement | null {
  const {requirements} = groupByWidgetId(props)

  if (requirements && requirements.length > 0) {
    return (
      <Grid xs={12} item>
        <Paper className={classes.root} radius="L">
          <Requirements widgets={requirements} />
        </Paper>
      </Grid>
    )
  }

  return null
}
